/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BlockIcon16Solid = forwardRef('BlockIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1ZM5.243 3.828a5 5 0 0 1 6.929 6.929l-6.93-6.929ZM3.828 5.243a5 5 0 0 0 6.929 6.929l-6.929-6.93Z" })));
});
